// extracted by css-extract-rspack-plugin
export default {"dropCursor":"MEKA5"};